import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[NumberType]",
})
export class NumberOnlyDirective {
  // Allow decimal numbers. The \. is only allowed once to occur
  private regex: RegExp = new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g);

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  @Input() NumberType: string;
  @Input() ngModel: string;
  private specialKeys: Array<string> = ["Backspace", "Tab", "End", "Home"];

  constructor(private el: ElementRef) {}

  @HostListener("input", ["$event"])
  onKeyPress(event: InputEvent) {
    let value: string = this.el.nativeElement.children[0].children[0].value;
    let newValue = "";

    switch (this.NumberType) {
      case "phone":
        this.el.nativeElement.children[0].children[0].value =
          value.length < 2 ? this.ngModel : value.replace(/[^+ 0-9]/g, "");
        break;
      case "date":
        newValue = value.replace(/[^\d+(\/\d+)*$]/g, "");

        if (value.length == 2 || value.length === 5) {
          if (event.inputType === "deleteContentBackward") {
            newValue = newValue.slice(0, newValue.length - 1);
          } else {
            newValue = newValue + "/";
          }
        }
        this.el.nativeElement.children[0].children[0].value = newValue;
      default:
        break;
    }
  }

  ngOnInit() {}
}
